angular.module("app").directive("colorFrequencyPharmaCompany", () => {
  let link = (scope) => {

  };

  return {
    restrict: "E",
    templateUrl: "app/directives/dbColorFrequencyPharmaCompany/dbColorFrequencyPharmaCompanyView.html",
    link: link,
    scope: {
      data: "="
    }
  };
});
